import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';

export default function ServiceCard3D({ index = 0 }) {
  const mountRef = useRef(null);
  const frameRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    // Scene setup
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });

    renderer.setSize(120, 120);
    renderer.setClearColor(0x000000, 0);
    mount.appendChild(renderer.domElement);

    // Geometry
    const geometries = [
      new THREE.BoxGeometry(1.5, 1.5, 1.5),
      new THREE.ConeGeometry(1, 2, 6),
      new THREE.SphereGeometry(1, 16, 12),
      new THREE.CylinderGeometry(0.8, 0.8, 1.5, 8)
    ];

    const colors = [0x2563eb, 0x1d4ed8, 0x3b82f6, 0x60a5fa];

    const geometry = geometries[index % geometries.length];
    const material = new THREE.MeshPhongMaterial({
      color: colors[index % colors.length],
      shininess: 80,
      transparent: true,
      opacity: 0.8
    });

    const mesh = new THREE.Mesh(geometry, material);
    scene.add(mesh);

    // Lighting
    scene.add(new THREE.AmbientLight(0xffffff, 0.5));

    const pointLight = new THREE.PointLight(0x60a5fa, 0.8, 100);
    pointLight.position.set(2, 2, 2);
    scene.add(pointLight);

    camera.position.z = 4;

    const speeds = [0.01, 0.008, 0.012, 0.006];
    const speed = speeds[index % speeds.length];

    const animate = () => {
      frameRef.current = requestAnimationFrame(animate);
      mesh.rotation.x += speed;
      mesh.rotation.y += speed * 1.2;
      renderer.render(scene, camera);
    };
    animate();

    // Cleanup
    return () => {
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
      mount.removeChild(renderer.domElement);
      renderer.dispose();
    };
  }, [index]);

  return (
    <div
      ref={mountRef}
      className="w-full h-full flex items-center justify-center opacity-20 group-hover:opacity-40 transition-opacity duration-300"
    />
  );
}
